import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  apiDeletePushSubscription,
  apiGetUnreadCount,
  apiListNotifications,
  apiMarkAllRead,
  apiMarkNotificationRead,
  apiRegisterPushSubscription,
} from '@/lib/api';
import { qk } from '@/lib/queryKeys';
import { useAuth } from '@/contexts/AuthContext';

export function useUnreadCount() {
  const { user } = useAuth();
  return useQuery({
    queryKey: qk.notificationsUnread(),
    queryFn: () => apiGetUnreadCount().then((r) => r.unread),
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
    enabled: !!user,
  });
}

export function useNotifications() {
  return useQuery({
    queryKey: qk.notifications(),
    queryFn: () => apiListNotifications({ limit: 50 }).then((r) => r.items),
    refetchOnWindowFocus: true,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: apiMarkNotificationRead,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}

export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: apiMarkAllRead,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}

export function useRegisterPushSubscription() {
  return useMutation({ mutationFn: apiRegisterPushSubscription });
}

export function useDeletePushSubscription() {
  return useMutation({ mutationFn: apiDeletePushSubscription });
}
